import { render, staticRenderFns } from "./StoriesArticleOverlap.vue?vue&type=template&id=4a0b9ec0&scoped=true&"
import script from "./StoriesArticleOverlap.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleOverlap.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleOverlap.vue?vue&type=style&index=0&id=4a0b9ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0b9ec0",
  null
  
)

export default component.exports